import { PaginatedServiceResponseData } from "../PaginatedServiceResponseData";
import { AxiosResponse } from "axios";
import { Installation } from "@/model/data/Installation";

export class GetInstallationsEcrDataResData extends PaginatedServiceResponseData {
    public installationsEcrDataList: Installation[];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsEcrDataList = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ResultList && obj.ResultList.length > 0) {
            obj.ResultList.forEach((e) => {
                var inst = new Installation();
                inst.parse(e);
                this.installationsEcrDataList.push(inst);
            });
        }
    }
}
